import axios from 'axios';

const BookdocApi = {
    getActivCategories: () => {
        return axios.request({
            url: `/api/activ_rewards/categories`,
            baseURL: process.env.REACT_APP_API_DOMAIN
        }).then((response) => {
            return response.data;
        });
    },
    getAwards: () => {
        return axios.request({
            url: `/api/awards`,
            baseURL: process.env.REACT_APP_API_DOMAIN
        }).then((response) => {
            return response.data;
        });
    },

    getActivRewards: (option) => {
        const params = new URLSearchParams(option);
        return axios.request({
            url: `/api/activ_rewards/rewards/web_index?${params.toString()}`,
            baseURL: process.env.REACT_APP_API_DOMAIN
        }).then((response) => {
            return response.data;
        });
    },


    getEMCDetails: (option) => {
        return axios.request({
            url: `/api/medical_certificates/find/${option["reference_id"]}`,
            baseURL: process.env.REACT_APP_API_DOMAIN
        }).then((response) => {
            return response.data;
        }).catch(error => {
          if (error.response.status === 422) {
            // Handle the 422 error
            return error.response.data;
          } else {
            // Handle other errors
            return {errors: [error.message]};
          }
        });;
    },
};

export default BookdocApi;
